import { useState } from 'react';
import { Text } from '@shared/components/Text';
import { MBHover } from '@shared/components/hover';
import { Colors } from '@shared/styles';

interface SeenHoverLinkProps {
  content: string;
  color: string;
}

export function SeenHoverLink({ content, color }: SeenHoverLinkProps) {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <MBHover
      hoverStyle={{ textDecoration: 'underline', color: Colors.v2.gray30 } as any}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <Text size="caption2" color={isHovered ? Colors.v2.gray60 : color}>
        {content}
      </Text>
    </MBHover>
  );
}
